module.exports = __webpack_public_path__ + "static/media/GroundingTechniques.e709d5f4.mp3";